import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSession } from '../hooks/useSession';

const SessionStatus: React.FC = () => {
  const { user, token, loading } = useAuth();
  const { isActive } = useSession();

  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        background: '#ff9800',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        zIndex: 9999,
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
      }}>
        🔄 Authenticating...
      </div>
    );
  }

  if (!user || !token) {
    return (
      <div style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        background: '#f44336',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '20px',
        fontSize: '12px',
        zIndex: 9999,
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
      }}>
        ❌ Not Authenticated
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: '#4caf50',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '20px',
      fontSize: '12px',
      zIndex: 9999,
      boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
      cursor: 'pointer'
    }}
    onClick={() => {
      console.log('Auth Debug Info:', {
        user,
        token: token ? `${token.substring(0, 20)}...` : null,
        isActive,
        timestamp: new Date().toISOString()
      });
    }}
    title="Click to see debug info in console"
    >
      ✅ {user.firstName || user.email} - Session Active
    </div>
  );
};

export default SessionStatus;
